<template>
  <v-dialog v-model="modal.open" persistent width="400">
    <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
      <v-card class="app-card" style="margin-bottom: 0px;">
        <v-card-title class="app-card-title">
          Confirmar Pagamento
        </v-card-title>

        <v-card-text class="app-card-content">                  
          <v-textarea
            v-model="form.observation"
            :disabled="isLoading"
            label="Observação do pagamento"            
            outlined
            dense            
            placeholder="Ex:. pagamento realizado via pix"
            class="mt-5"
            color="success"
            :rules="[rules.required]"
          />

          <v-text-field
            v-model="form.amount"
            :disabled="isLoading"
            label="Valor"
            type="number"
            outlined
            dense            
            placeholder="Ex:. 100"
            class="mt-5"
            color="success"
            :rules="[rules.number, rules.positive]"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn color="error" depressed @click="close()">
            Cancelar
          </v-btn>
          <v-btn color="success" type="submit" depressed :disabled="isLoading">
            {{ isLoading ? "Confirmando..." : "Confirmar" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import PaymentService from '@/services/pagamentos.service';
  
  export default {
    name: 'OrderPaymentConfirmModal',

    props: {
      payment: {
        type: Object,
        required: true
      }
    },

    data: () => ({
      modal: {
        open: true
      },

      form: {
        observation: null,
        amount: null
      },

      isLoading: false,

      rules: {
        required: value => !!value || 'Campo obrigatório',                
        number: value => !isNaN(value) || 'Valor inválido',
        positive: value => value >= 0 || 'Valor deve ser maior que 0'
      }
    }),

    methods: {
      onSubmit() {
        this.isLoading = true;

        const isValid = this.$refs.form.validate();
        if (!isValid) return;

        const body = {
          observation: this.form.observation,
          amount: this.form.amount
        };

        PaymentService.confirm(this.payment.id, body).subscribe({
          next: () => {
            this.isLoading = false;
            this.$emit('confirmed');            
          },
          error: () => {
            this.isLoading = false;            
          }
        });
      },

      close() {        
        this.$emit('close');
      },
    }
  }
</script>